import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  styled,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import SalesInfoComponent from "./SalesInfoComponent";
import Utils from "../../core/Utils";
import { getServiceItemFromProduct } from "../../helpers/productHelper";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const AddNewProduct = (props) => {
  const {
    open,
    closeAddNewProduct,
    handleAddNewProductIntake,
    Catlist,
    Deptlist,
  } = props;

  const [name, setName] = useState("");
  const [sku, setsku] = useState("");
  const [productCode, setProductCode] = useState("");
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");
  const [description, setDescription] = useState("");
  const [priceExclusive, setPriceExclusive] = useState("");
  const [taxPercentage, setTaxPercentage] = useState("");
  const [inclusiveOfTax, setInclusiveOfTax] = useState(false);
  const [isReviewProduct, setIsReviewProduct] = useState(false);
  const [actualPriceExclusive, setActualPriceExclusive] = useState("");
  const [actualMunicipalTaxAmount, setActualMunicipalTaxAmount] = useState("");
  const [actualtaxAmount, setActualTaxAmount] = useState("");
  const [cost, setCost] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [taxAmount, setTaxAmount] = useState("");
  const [addProductDisabled, setAddPrductDisabled] = useState(true);
  const [measuringUnit, setMeasuringUnit] = useState("Number");
  const [isDropdown, setIsDropdown] = useState(false);
  const [isDropdown1, setIsDropdown1] = useState(false);
  const [department, setDepartment] = useState("");
  const [departmentDescription, setDepartmentDescription] = useState("");
  const [category, setCategory] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [hsn, setHSN] = useState("");

  useEffect(() => {
    checkDetailsFilled();
  }, [
    name,
    productCode,
    description,
    taxPercentage,
    cost,
    actualPriceExclusive,
  ]);

  useEffect(() => {
    setDefaultValues();
  }, []);

  const setDefaultValues = () => {
    setMeasuringUnit("Number");
    setName("");
    setsku("");
    setProductCode("");
    setColor("");
    setSize("");
    setDescription("");
    setPriceExclusive("");
    setTaxPercentage("");
    setInclusiveOfTax(false);
    setIsReviewProduct(false);
    setActualPriceExclusive("");
    setActualMunicipalTaxAmount("");
    setActualTaxAmount("");
    setCost("");
    setTotalPrice("");
    setTaxAmount("");
    setAddPrductDisabled(true);
    setMeasuringUnit("Number");
    setIsDropdown(false);
    setIsDropdown1(false);
    setDepartment("");
    setDepartmentDescription("");
    setCategory("");
    setCategoryDescription("");
    setHSN("");
  };

  const hanldeAddProduct = () => {
    var _purchasingCost = Utils.ConvertToFloat(cost);
    var _sellingPrice = Utils.IsNullOrEmpty(actualPriceExclusive)
      ? 0
      : Utils.ConvertToFloat(actualPriceExclusive);
    var _taxPercent = Utils.ConvertToFloat(taxPercentage);
    var _priceIncludingTax = inclusiveOfTax
      ? Utils.ConvertToFloat(totalPrice)
      : 0;
    let obj = {
      service: false,
      isMaterial: false,
      labour: false,
      hsn: "",
      class: "",
      department: "",
      fineline: "",
      serviceTime: 0,
      shortDesc: name,
      code: productCode,
      description: description,
      cost: _purchasingCost,
      price: _sellingPrice,
      retailPrice: Utils.ConvertToFloat(taxAmount),
      priceIncludingTax: _priceIncludingTax,
      inclusiveOfTax: inclusiveOfTax,
      taxPercent: _taxPercent,
      measuringUnit: measuringUnit,
      id: Utils.CreateGuid(),
      class: category,
      classDescription: categoryDescription,
      department: department,
      departmentDescription: departmentDescription,
    };
    var serviceItem = getServiceItemFromProduct(obj, 1, true);
    serviceItem.Class = category;
    serviceItem.ClassDescription = categoryDescription;
    serviceItem.Department = department;
    serviceItem.DepartmentDescription = departmentDescription;
    serviceItem.Color = color;
    serviceItem.Sku = sku;
    serviceItem.Size = size;
    serviceItem.HSN = hsn;
    handleAddNewProductIntake(serviceItem);
    setDefaultValues();
  };

  const handleSwitchChangeCat = (event) => {
    setIsDropdown1(event.target.checked);
    setCategory("");
  };

  const handleSwitchChange = (event) => {
    setIsDropdown(event.target.checked);
    setDepartment("");
  };

  const checkDetailsFilled = () => {
    var disable =
      Utils.IsNullOrEmpty(name) ||
      Utils.IsNullOrEmpty(description) ||
      Utils.IsNullOrEmpty(productCode) ||
    setAddPrductDisabled(disable);
  };

  return (
    <>
      {open && (
        <BootstrapDialog
          onClose={closeAddNewProduct}
          aria-labelledby="customized-dialog-title"
          className="cs-modal-sec"
          open={open}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={closeAddNewProduct}
          >
            <Typography
              level="h3"
              component="h3"
              fontWeight="600"
              fontSize="2rem"
              className="h3"
            >
              Add New Product
            </Typography>
          </BootstrapDialogTitle>
          <DialogContent dividers className="modal-dialog-content font-size-14">
            <Stack sx={{ minWidth: 120 }} spacing={2}>
              <FormControl fullWidth>
                <TextField
                  inputProps={{ style: { fontSize: 13 } }}
                  label="Name"
                  type="text"
                  value={name}
                  error={!name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter name"
                />
              </FormControl>
              <Stack direction="row" spacing={2}>
                <FormControl fullWidth>
                  <TextField
                    inputProps={{
                      style: { fontSize: 13 },
                    }}
                    label="Product Code"
                    type="text"
                    value={productCode}
                    error={!productCode}
                    onChange={(e) => setProductCode(e.target.value)}
                    placeholder="Enter product code"
                  />
                </FormControl>
                 <FormControl fullWidth>
                <TextField
                  inputProps={{ style: { fontSize: 13 } }}
                  label="Description "
                  type="text"
                  error={!description}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                />
              </FormControl>
              </Stack>


              <SalesInfoComponent
                priceExclusive={priceExclusive}
                setPriceExclusive={setPriceExclusive}
                setActualTaxAmount={setActualTaxAmount}
                setActualMunicipalTaxAmount={setActualMunicipalTaxAmount}
                setActualPriceExclusive={setActualPriceExclusive}
                inclusiveOfTax={inclusiveOfTax}
                setInclusiveOfTax={setInclusiveOfTax}
                cost={cost}
                setCost={setCost}
                taxPercentage={taxPercentage}
                setTaxPercentage={setTaxPercentage}
                totalPrice={totalPrice}
                setTotalPrice={setTotalPrice}
                taxAmount={taxAmount}
                setTaxAmount={setTaxAmount}
                isFromProductIntakes={true}
              />

            </Stack>
          </DialogContent>
          <DialogActions style={{ padding: "15px" }}>
            <FormControl>
              <Button
                type="submit"
                variant="contained"
                className="btn btn-secondary"
                onClick={closeAddNewProduct}
              >
                Cancel
              </Button>
            </FormControl>
            <FormControl>
              <Button
                type="submit"
                variant="contained"
                className="btn btn-primary"
                disabled={addProductDisabled}
                onClick={hanldeAddProduct}
              >
                Save
              </Button>
            </FormControl>
          </DialogActions>
        </BootstrapDialog>
      )}
    </>
  );
};

export default AddNewProduct;
